import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-vehicle-color.dto';
export * from './dtos/update-vehicle-color.dto';
export * from './dtos/vehicle-color-list.dto';
export * from './dtos/vehicle-color-record.dto';
export * from './dtos/vehicle-color-search.dto';
export * from './dtos/vehicle-colors-stats.dto';

export * from './enums/vehicle-color-type.enum';

export * from './types/vehicle-colors-filters';

export * from './validators/schemas/create-vehicle-color.schema';
export * from './validators/schemas/update-vehicle-color.schema';

export const vehicleColorValidators = { canCreateOrUpdate };
